import React from 'react';
import { useAuth } from 'react-oidc-context';

type Props = {
  children: React.ReactElement;
};

export default function ProtectedRoute({ children }: Props) {
  const auth = useAuth();
  const hasAuth = Boolean(auth && typeof auth.isAuthenticated !== 'undefined');
  const isEnvConfigured = true; // Rely on runtime-config; do not leak build envs

  // If OIDC is not configured, do not block the route. Surface a warning and let the app work.
  if (!isEnvConfigured) {
    // eslint-disable-next-line no-console
    console.warn('[OIDC] Env not configured. Skipping route protection.');
    return children;
  }

  if (!hasAuth) {
    // Kein Auth-Provider verfügbar (z.B. OIDC nicht konfiguriert) -> Route nicht blockieren
    return children;
  }

  if (auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div>Authentifiziere...</div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center space-y-4 p-6 text-center">
        <div className="text-red-600 font-medium">Fehler bei der Anmeldung</div>
        <div className="text-sm text-gray-600 break-all">{String(auth.error)}</div>
        <button
          onClick={() => auth.signinRedirect().catch((err) => {
            // eslint-disable-next-line no-console
            console.error('OIDC signinRedirect failed:', err);
            alert('Login konnte nicht gestartet werden. Bitte OIDC-Konfiguration prüfen.');
          })}
          className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-50"
        >
          Erneut anmelden
        </button>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center space-y-4 p-6 text-center">
        <div className="text-gray-800">Bitte melden Sie sich an, um fortzufahren.</div>
        <button
          onClick={() => auth.signinRedirect().catch((err) => {
            // eslint-disable-next-line no-console
            console.error('OIDC signinRedirect failed:', err);
            alert('Login konnte nicht gestartet werden. Bitte OIDC-Konfiguration prüfen.');
          })}
          className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-50"
        >
          Login starten
        </button>
      </div>
    );
  }

  return children;
}


